import React from "react";
import Head from "next/head";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { WEBPAGE_TITLE } from "@utils/Constants";
import Page from "@components/Layout/page";
import FlexContainer from "@components/FlexContainer/FlexContainer";
import styles from "./PricingPage.module.scss";
import PriceList from "@components/PriceList/PriceList";
import { Leaf } from "@components/Leaf/Leaf";
import { ContentContainer } from "@components/ContentContainer/ContentContainer";

export default function PricingPage() {
    const t = useTranslations("PricingPage");
    const tc = useTranslations("CompanySolutionsPage");

    return (
        <div style={{ overflowX: "hidden" }}>
            <Page fluid bodyClassName={styles.pageBody}>
                <Head>
                    <title key="site_title">
                        {"Áskriftarleiðir Laufsins - " + WEBPAGE_TITLE}
                    </title>
                    <meta name="keywords" content="Áskriftarleiðir Laufsins" />
                    <meta
                        property="og:title"
                        content={`${WEBPAGE_TITLE} - Áskriftarleiðir Laufsins`}
                        key="og:title"
                    />
                    <meta
                        name="og:description"
                        content="Áskriftarleiðir Laufsins"
                        key="og:description"
                    />
                    <meta
                        name="description"
                        content="Áskriftarleiðir Laufsins"
                    />
                </Head>

                <Leaf className={styles.leaf2} plain />

                <FlexContainer
                    column
                    justifyContent="center"
                    alignItems="center"
                    className={styles.container}
                >
                    <div className={styles.topTextContainer}>
                        <div className={styles.borderedContainer}>
                            <h1 className={styles.mainText}>
                                {t("subscription_options_for_laufinn")}
                            </h1>
                        </div>
                    </div>
                </FlexContainer>

                <ContentContainer>
                    <article
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: 10,
                            marginRight: 10,
                        }}
                    >
                        <section className={styles.companyPriceSection}>
                            <PriceList />
                        </section>
                    </article>
                </ContentContainer>

                <section className={styles.diagnostic}>
                    <div className={styles.diagnosticInner}>
                        <h2 className={styles.diagnosticTitle}>
                            {tc("biz_diagnostic_title")}
                        </h2>
                        <p className={styles.diagnosticDesc}>
                            {tc("biz_diagnostic_desc")}
                        </p>
                        <Link className={styles.diagnosticBtn} href="/greining">
                            {tc("biz_diagnostic_btn")}
                        </Link>
                    </div>
                </section>
            </Page>
        </div>
    );
}
